import { ERROR_MESSAGE } from '@/constants';
import { toast } from '../toast';

export default {
  /**
   * 复制
   * @param data
   */
  copy: (data: string) => {
    uni.setClipboardData({
      data,
      success: () => {},
      fail: () => toast.message(ERROR_MESSAGE.copy),
    });
  },
  /**
   * 防抖
   * @param fn
   * @param delay
   * @returns
   */
  debounce: (fn: Function, delay: number) => {
    let timer: ReturnType<typeof setTimeout>;
    return (...args: any[]) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  },
  /** ? */
  promisify:
    (api: any): ((options: any, ...args: any) => Promise<any> | null) =>
    (options: any, ...args: any) =>
      new Promise((res, rej) =>
        api.apply(null, [
          {
            ...options,
            success: res,
            fail: (err: any) => {
              console.log(err);
              rej(err);
            },
          },
          ...args,
        ])
      ),
  /**
   * 判断一个变量是否为空或者空对象
   * @param target
   */
  isEmpty: (target: {} | null) => {
    // 判断变量是否为 null 或 undefined
    if (target == null) return true;
    // 如果是对象，则判断是否为空对象
    if (typeof target === 'object' && Object.keys(target).length === 0) {
      return true;
    }
    // 如果不是对象，则将变量转换成字符串后判断是否为空字符串
    if (typeof target !== 'object' && String(target).trim().length === 0) {
      return true;
    }
    // 其他情况返回 false
    return false;
  },
};
